<template>
  <div>
    <h1 class="pb-6 text-2xl font-semibold text-vice-teal-900">Your reflection</h1>

    <div class="grid grid-cols-10 gap-8">
      <div class="col-span-10 sm:col-span-6">
        <my-personal-goals></my-personal-goals>
        <what-card @reflectionChanged="update"></what-card>
        <so-what-card @reflectionChanged="update"></so-what-card>
        <now-what-card @reflectionChanged="update"></now-what-card>
      </div>
      <div class="col-span-10 sm:col-span-4">
        <!-- <interaction-feed></interaction-feed> -->
        <!-- <recommended-sessions class="mt-9"></recommended-sessions> -->
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import MyPersonalGoals from './Reflection/MyPersonalGoals.vue';
import WhatCard from './Reflection/WhatCard.vue';
import SoWhatCard from './Reflection/SoWhatCard.vue';
import NowWhatCard from './Reflection/NowWhatCard.vue';
// import InteractionFeed from './Reflection/InteractionFeed.vue';
// import RecommendedSessions from './Reflection/RecommendedSessions.vue';

export default {
  name: 'Reflection',
  components: {
    // RecommendedSessions,
    // InteractionFeed,
    NowWhatCard,
    SoWhatCard,
    WhatCard,
    MyPersonalGoals,
  },
  methods: {
    update(data) {
      axios.post(route('reflection.update'), data).then((response) => response.data);
    },
  },
};
</script>
